export default "__VITE_ASSET__C_8h4c0D__"